import styled from 'styled-components';
import { colors } from 'modules/common/styles';

const SortItem = styled.div`
  background: #fff;
  border: 1px dashed #B1B1B1;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  padding: 8px 12px;
  margin-bottom: 10px;
  z-index: ${props => (props.zIndex ? props.zIndex : 2000)};
  display: flex;
  justify-content: space-between;
  left: ${props => props.isDragging && props.isModal ? '40px!important' : 'auto'};
  &:last-child {
    margin-bottom: 30px;
  }
  &:hover {
    box-shadow: 0 2px 8px ${colors.shadowPrimary};
    border-color: ${colors.colorPrimary};
  }
`;
const SortItemWithoutImportant = styled.div`
  background: #fff;
  border: 1px ${props => props.solidBorder ? "solid" : "dashed"} #B1B1B1;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  padding: 8px 12px;
  margin-bottom: 10px;
  z-index: ${props => (props.zIndex ? props.zIndex : 2000)};
  // display: flex;
  // justify-content: space-between;
  left: ${props => props.isDragging && props.isModal ? '40px' : 'auto'};
  &:last-child {
    margin-bottom: 30px;
  }
  &:hover {
    box-shadow: 0 2px 8px ${colors.shadowPrimary};
    border-color: ${colors.colorPrimary};
  }
`;

const SortableWrapper = styled.div`
  width: 100%;
  // overflow-y: auto;
  flex: 1;
  label {
    margin: 0;
  }

  .sort-div{
    // display: flex;
    // align-items: center;
    // margin-bottom: 20px;
  }

  .sort-item{
    left: 67px !important;
    width: 100%;
    margin:0;
  }

  .sort-span{
    background: #D9D9D9;
    color: rgba(0,0,0,0.23);
    margin-right: 20px;
    line-height: normal;
    font-weight: 900;
    font-size: 16px;
    border-radius: 50%;
    min-width: 33px;
    min-heigth: 33px;
    width: 33px;
    height: 33px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 576px) {
    .sort-span {
      margin-right: 5px;
    }
    .sort-item {
      padding: 6px;
    }
    input {
      height: 40px;
      padding: 0px 12px;
      font-size: 12px;
    }
    .column-label{
      font-size: 13px;
    }
  }
`;

const DragHandler = styled.div`
  display: flex;
  width: 20px;
  margin-right: 10px;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
  i {
    color: ${colors.colorLightGray};
  }
`;

export { SortItem, SortableWrapper, DragHandler, SortItemWithoutImportant };



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/styles/sort.js